import React from 'react';

export const PartnerCarouselDefaultConfigs = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: false,
  initialSlide: 0,
  slide: 'ul',
  draggable: true,
  className: 'slider',
  dotsClass: 'dots',
  arrows: true,
  dots: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 674,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1.9,
        slidesToScroll: 1
      }
    }
  ]
};

export const carouselRepositoryDefaultConfigs = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 2,
  autoplay: false,
  initialSlide: 0,
  slide: 'ul',
  draggable: true,
  className: 'slider',
  dotsClass: 'dots',
  arrows: true,
  customPaging: (i) => <button></button>,
  responsive: [
    {
      breakpoint: 3000,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 674,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
  ]
};

export const PlanSlider = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  initialSlide: 0,
  slide: 'ul',
  draggable: true,
  className: 'slider',
  dotsClass: 'dots',
  arrows: false,
  responsive: [
    {
      breakpoint: 3000,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1365,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 674,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
  ]
};

export const DEFAULT_NOTIFICATION = {
  showOvRejection: false,
  show: false,
  message: '',
  type: '',
  eventHandler: () => {},
  onCancel: () => {}
};

export const UnauthSteps = [
  {
    stepId: 1,
    name: 'Company Details',
    detail: 'Step 1 of 4: To check network availability please add details of the site(s).'
  },
  {
    stepId: 2,
    name: 'Installation Address',
    detail: 'Step 2 of 4: Please select plan and configuration as per the requirement.'
  }
];

export const CarouselDefaultSetting = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  initialSlide: 0,
  slide: 'ul',
  draggable: true,
  className: 'slider',
  dotsClass: 'dots',
  arrows: false,
  responsive: [
    {
      breakpoint: 3000,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 674,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
  ]
};

export const OTP_NOTIFICATIONS = {
  SENT: 'OTP sent successfully',
  RE_SENT: 'OTP re sent successfully',
  VERIFIED: 'OTP verified successfully',
  FIELD_MESSAGE: 'Enter OTP sent to your mobile number.'
};

export const RESEND_OTP_TIME = {
  MIN: 1,
  SECONDS: 59
};

export const DEFAULT_RESEND_COUNT = 4;

export const DEFAULT_OTP_LENGTH = 4;
